import { TRESPONSE_BREAKDOWN_REASON_LIST } from '@monorepo/types';
import { ModifiersZTableModel } from '../../table.modifier';
import { TTableRowNode } from '../../table.type';

export const BREAKDOWN_REASON_LIST_TABLE_MODEL = {
  createModel: (items: TRESPONSE_BREAKDOWN_REASON_LIST['breakdownReasonListingInfo']) => {
    return ModifiersZTableModel.createTableModel(
      items,
      {
        padding: 8,
        select: {
          position: 'START',
          isMulti: true,
          size: 'DEFAULT',
        },
        headerConfig: [
          {
            type: 'TEXT_CELL',
            text: 'table_model.MACHINETYPE',
          },
          {
            type: 'TEXT_CELL',
            text: 'table_model.MACHINECATEGORY',
          },
          {
            type: 'TEXT_CELL',
            text: 'table_model.MACHINESUB-CATEGORY',
          },
          {
            type: 'TEXT_CELL',
            text: 'table_model.BREAKDOWNREASON',
          },
          {
            type: 'TEXT_CELL',
            text: 'table_model.IssueCategory',
          },
          {
            type: 'TEXT_CELL',
            text: '',
            widthInPx: 32,
          },
          {
            type: 'TEXT_CELL',
            text: '',
            widthInPx: 32,
          },
        ],
      },
      (item): TTableRowNode<TRESPONSE_BREAKDOWN_REASON_LIST['breakdownReasonListingInfo'][number]> => {
        return {
          type: 'ROW',
          rowItem: item,
          cells: [
            {
              type: 'TEXT_CELL',
              text: item.machineType,
            },
            {
              type: 'TEXT_CELL',
              text: item.machineCategory,
            },
            {
              type: 'TEXT_CELL',
              text: item.machineSubCategory || '--',
            },
            {
              type: 'TEXT_CELL',
              text: item.breakdownReasons
                .map((x) => x.reason)
                .slice(0, 2)
                .join(', '),
              ...(item.breakdownReasons?.length > 2 && {
                tag: {
                  tagContent: `+${item.breakdownReasons.length - 2}`,
                  tagTooltipContent: item.breakdownReasons
                    .map((x) => x.reason)
                    .slice(2)
                    .join(', '),
                  showTooltipEvent: 'hover',
                },
              }),
            },
            {
              type: 'TEXT_CELL',
              text: item.issueCategory ?? '- -',
            },
            {
              type: 'ACTION_CELL',
              actionType: 'EDIT',
              asIcon: true,
            },
            {
              type: 'ACTION_LIST_CELL',
              title: 'table_model.Actions',
              actions: [
                {
                  type: 'DELETE_BR',
                  displayText: 'table_model.DeleteBreakdownReasons',
                },
              ],
            },
          ],
        };
      },
    );
  },
};
